import { ReactNode } from 'react';

type Props = {
    productLink: ReactNode;
    productImage: ReactNode;
    productDescription: ReactNode;
    quantity?: ReactNode;
    price?: ReactNode;
}

export const ProjectSelectionDevice = ({
    productLink,
    productImage,
    productDescription,
    quantity,
    price,
}: Props) => (
    <div className="vss-project-selection-device">
        <div className="vss-project-selection-device__main">
            <div className="vss-project-selection-device__image">
                {productImage}
            </div>

            <div className="vss-project-selection-device__details">
                {productLink}

                <div className="vss-project-selection-device__description">
                    {productDescription}
                </div>
            </div>
        </div>

        {price || quantity ? (
            <div className="vss-project-selection-device__meta">
                {price ? (
                    <div className="vss-project-selection-device__price">
                        {price}
                    </div>
                ) : null}

                {quantity ? (
                    <div className="vss-project-selection-device__quantity">
                        {quantity}
                    </div>
                ) : null}
            </div>
        ) : null}
    </div>
);
